/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('carway.step4', function (el) {
        var stepFour = new Step4(el);
        stepFour.run();
    });
    var Step4 = /** @class */ (function () {
        function Step4(el) {
            this.el = el;
        }
        Step4.prototype.run = function () {
            this.runBeginCheckout();
        };
        Step4.prototype.runBeginCheckout = function () {
            var object = {
                event: "begin_checkout",
                ecommerce: {
                    currency: 'ISK',
                    value: Number(this.el.dataset.carPrice),
                    items: this.getItems(),
                },
            };
            this.pushToLayer(object);
        };
        Step4.prototype.getItems = function () {
            return JSON.parse(this.el.dataset.carPriceItems);
        };
        Step4.prototype.pushToLayer = function (object) {
            // @ts-ignore
            window.dataLayer = window.dataLayer || [];
            // @ts-ignore
            window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
            // @ts-ignore
            window.dataLayer.push(object);
        };
        return Step4;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
